import React from "react";
import { useAppDispatch } from "@/services/hooks";
import GlobalToolAccordion from "../GlobalToolAccordion";
import DisplayTemplatesContainer from "./DisplayTemplatesContainer";
import TemplateForm from "./TemplateForm";
import UpdateTemplate from "./UpdateTemplate";
// Save the settings required / optional to redux
import { saveSettingsRequired, saveSettingsOptional } from "@/services/templateServices/templateAction";

/** The template row DisplayTemplatesContainer hands to `handleUpdate` (a lean template). */
type TemplateRow = { _id?: string; name?: string };

// SCRUM-2118: the accordion lives in GlobalToolAccordion; this screen is its configuration.
// The template forms read the selected settings from redux, so they are cleared whenever a
// closed card opens and after back-to-list, exactly where the screen cleared them before.
const TemplateContainer = () => {
  const dispatch = useAppDispatch();
  const resetSettings = () => {
    dispatch(saveSettingsRequired([]));
    dispatch(saveSettingsOptional([]));
  };
  return (
    <GlobalToolAccordion<TemplateRow>
      headerName="Templates"
      listTitle="Available Templates"
      readOnlyListTitle="Available Templates"
      noun="template"
      titleOf={(template) => template.name}
      emptyElem={{}}
      onReset={resetSettings}
      renderList={(handleUpdate) => <DisplayTemplatesContainer handleUpdate={handleUpdate} />}
      renderCreate={(back) => <TemplateForm switchToDesignListHandler={back} />}
      renderUpdate={(template, back) => <UpdateTemplate template={template} switchToDesignListHandler={back} />}
    />
  );
};

export default TemplateContainer;
